import { render, staticRenderFns } from "./bottom-menu.vue?vue&type=template&id=f5dba3a6&"
import script from "./bottom-menu.vue?vue&type=script&lang=js&"
export * from "./bottom-menu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports